<mat-form-field [appearance]="appearance" [class.full-width]="fullWidth">
    <mat-label>{{ label }}</mat-label>
    <input
        matInput
        [id]="inputId"
        [mtxColorpicker]="picker"
        [(ngModel)]="value"
        [placeholder]="placeholder"
        [disabled]="disabled"
        (ngModelChange)="onModelChange($event)"
        readonly
    />
    <mtx-colorpicker-toggle matSuffix [for]="picker">
        <mat-icon mtxColorpickerToggleIcon>keyboard_arrow_down</mat-icon>
    </mtx-colorpicker-toggle>
    <mtx-colorpicker #picker [id]="pickerId"> </mtx-colorpicker>
</mat-form-field>
